import React from 'react';
import './style.scss';

export const Modal = ({ show, onClose, children }) => {
  if (show) {
    return (
      <>
        <div className={'overlay'} onClick={onClose}></div>
        <div className={`modal-container `}>{children}</div>
      </>
    );
  } else {
    return <> </>;
  }
};
